"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_class_1 = require("@opten/dom/add-class");
var has_class_1 = require("@opten/dom/has-class");
var remove_class_1 = require("@opten/dom/remove-class");
var get_selector_element_from_element_1 = require("@opten/dom/get-selector-element-from-element");
var add_transition_end_listener_1 = require("@opten/transition/add-transition-end-listener");
var event_namespace_factory_1 = require("@opten/events/event-namespace-factory");
var stringCollapse = 'Collapse';
var Collapse = /** @class */ (function () {
    function Collapse(element, options) {
        var _this = this;
        this.element = element;
        this.options = {
            activeClass: 'is--active',
            animateProp: 'height',
            collapsingClass: 'collapse--collapsing',
            componentClass: 'collapse',
            showClass: 'collapse--show',
            showClassDesktop: 'collapse--md-show',
            desktopWidth: 1024,
            transitionDuration: 600,
            isHideable: true,
            closeSiblings: true,
            useShowClassDesktop: false,
            dataParentSelector: 'data-parent',
            dataTargetSelector: 'data-target',
            dataToggleSelector: 'data-toggle',
            hrefSelector: 'href'
        };
        this.isTransitioning = false; // when true it will prevent click handlers
        // event names
        this.eventNamespaceFn = event_namespace_factory_1.default('opten.collapse');
        this.handleClick = function (event) {
            // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
            var trigger = event && event.currentTarget;
            if (trigger && trigger.tagName === 'A') {
                event.preventDefault();
            }
            var target = get_selector_element_from_element_1.default(trigger, _this.options.dataTargetSelector);
            var data = target[stringCollapse];
            if (!data) {
                data = trigger[stringCollapse];
            }
            if (target) {
                Collapse.getInstance(target, data.options).toggle();
            }
        };
        this.options = __assign({}, this.options, options);
        if (!this.options.parentElement) {
            this.options.parentElement = get_selector_element_from_element_1.default(element, this.options.dataParentSelector, false);
        }
        this.init();
    }
    Object.defineProperty(Collapse.prototype, "toggles", {
        // TODO: Uggly naming
        get: function () {
            return this.triggers;
        },
        enumerable: true,
        configurable: true
    });
    Collapse.prototype.isOpen = function () {
        if (this.options.useShowClassDesktop &&
            window.outerWidth >= this.options.desktopWidth &&
            has_class_1.default(this.element, this.options.showClassDesktop)) {
            add_class_1.default(this.element, this.options.showClass);
        }
        remove_class_1.default(this.element, this.options.showClassDesktop);
        return has_class_1.default(this.element, this.options.showClass);
    };
    Collapse.prototype.toggle = function () {
        if (this.isOpen()) {
            if (this.options.isHideable) {
                this.hide();
            }
        }
        else {
            this.show();
        }
    };
    Collapse.prototype.show = function () {
        var _this = this;
        if (this.isTransitioning || this.isOpen()) {
            return;
        }
        if (this.options.closeSiblings && this.parent) {
            var selector = "[" + this.options.dataParentSelector + "=\"#" + this.parent.id + "\"]";
            var actives = Array.from(this.parent.querySelectorAll(selector + "." + this.options.showClass + ", " + selector + "." + this.options.collapsingClass)).filter(function (active) { return active !== _this.target; });
            if (actives && actives.length) {
                var anyTransitioning = actives.filter(function (active) {
                    var collapseInstance = active[stringCollapse];
                    return collapseInstance && collapseInstance.isTransitioning;
                });
                if (anyTransitioning.length) {
                    return;
                }
                actives.forEach(function (active) {
                    return Collapse.getInstance(active).hide();
                });
            }
        }
        this._handleShow(this.element, this.triggers);
    };
    Collapse.prototype.hide = function () {
        if (this.isTransitioning || !this.isOpen()) {
            return;
        }
        this._handleClose(this.element, this.triggers);
    };
    Collapse.prototype.destroy = function () {
        var element = this.element;
        if (element[stringCollapse]) {
            element[stringCollapse] = null;
            remove_class_1.default(element, this.options.componentClass);
            remove_class_1.default(element, this.options.collapsingClass);
            remove_class_1.default(element, this.options.showClass);
            if (this.options.animateProp) {
                element.style[this.options.animateProp] = null;
            }
        }
    };
    Collapse.prototype.init = function () {
        var _this = this;
        var e_1, _a;
        // todo: only initalize once, like bootstrap does it?
        this.triggers = Array.from(document.querySelectorAll("[" + this.options.hrefSelector + "=\"#" + this.element.id + "\"], [" + this.options.dataTargetSelector + "=\"#" + this.element.id + "\"]"));
        // todo: why do we need that?
        var toggles = Array.from(document.querySelectorAll("[" + this.options.dataToggleSelector + "=\"collapse\"]"));
        try {
            for (var toggles_1 = __values(toggles), toggles_1_1 = toggles_1.next(); !toggles_1_1.done; toggles_1_1 = toggles_1.next()) {
                var toggle = toggles_1_1.value;
                var target = get_selector_element_from_element_1.default(toggle, this.options.dataTargetSelector);
                if (target !== null && target === this.element) {
                    this.target = target;
                    this.triggers.push(toggle);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (toggles_1_1 && !toggles_1_1.done && (_a = toggles_1.return)) _a.call(toggles_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.parent = this.options.parentElement;
        // init
        if (!(stringCollapse in this.element)) {
            // prevent adding event handlers twice
            this.triggers.forEach(function (trigger) {
                return trigger.addEventListener('click', _this.handleClick, false);
            });
        }
        if (this.parent) {
            Array.from(this.parent.querySelectorAll("[" + this.options.dataToggleSelector + "=\"collapse\"][" + this.options.dataParentSelector + "=\"#" + this.parent.id + "\"]")).forEach(function (element) {
                _this._addAriaAndCollapsedClass(get_selector_element_from_element_1.default(element, _this.options.dataTargetSelector), [element]);
            });
        }
        else {
            this._addAriaAndCollapsedClass(this.element, this.triggers);
        }
        add_class_1.default(this.element, this.options.componentClass);
        this.element[stringCollapse] = this;
    };
    Collapse.prototype._handleShow = function (collapseElement, triggers) {
        var _this = this;
        this.eventNamespaceFn(collapseElement, 'show');
        remove_class_1.default(collapseElement, this.options.componentClass);
        add_class_1.default(collapseElement, this.options.collapsingClass);
        if (this.options.animateProp) {
            collapseElement.style[this.options.animateProp] =
                collapseElement.scrollHeight + 'px';
        }
        if (triggers && triggers.length) {
            triggers.forEach(function (trigger) {
                add_class_1.default(trigger, _this.options.activeClass);
                trigger.setAttribute('aria-expanded', 'true');
            });
        }
        this.isTransitioning = true;
        add_transition_end_listener_1.default(collapseElement, function () {
            remove_class_1.default(collapseElement, _this.options.collapsingClass);
            add_class_1.default(collapseElement, _this.options.componentClass);
            add_class_1.default(collapseElement, _this.options.showClass);
            _this.isTransitioning = false;
            if (_this.options.animateProp) {
                collapseElement.style[_this.options.animateProp] = null;
            }
            _this.eventNamespaceFn(collapseElement, 'shown');
        }, this.options.transitionDuration);
    };
    Collapse.prototype._handleClose = function (collapseElement, triggers) {
        var _this = this;
        this.eventNamespaceFn(collapseElement, 'hide');
        if (this.options.animateProp) {
            collapseElement.style[this.options.animateProp] =
                collapseElement.scrollHeight + 'px';
        }
        add_class_1.default(collapseElement, this.options.collapsingClass);
        remove_class_1.default(collapseElement, this.options.componentClass);
        remove_class_1.default(collapseElement, this.options.showClass);
        // force reflow to enable transition
        collapseElement.offsetWidth; // tslint:disable-line
        if (triggers && triggers.length) {
            triggers.forEach(function (trigger) {
                var target = get_selector_element_from_element_1.default(trigger, _this.options.dataTargetSelector);
                if (target !== null) {
                    if (!has_class_1.default(target, _this.options.showClass)) {
                        remove_class_1.default(trigger, _this.options.activeClass);
                        trigger.setAttribute('aria-expanded', 'false');
                    }
                }
            });
        }
        this.isTransitioning = true;
        if (this.options.animateProp) {
            collapseElement.style[this.options.animateProp] = null;
        }
        add_transition_end_listener_1.default(collapseElement, function () {
            _this.isTransitioning = false;
            remove_class_1.default(collapseElement, _this.options.collapsingClass);
            add_class_1.default(collapseElement, _this.options.componentClass);
            if (_this.options.animateProp) {
                collapseElement.style[_this.options.animateProp] = null;
            }
            _this.eventNamespaceFn(collapseElement, 'hidden');
        }, this.options.transitionDuration);
    };
    Collapse.prototype._addAriaAndCollapsedClass = function (element, triggers) {
        var _this = this;
        if (element) {
            var isOpen_1 = has_class_1.default(element, this.options.showClass);
            if (triggers && triggers.length) {
                triggers.forEach(function (trigger) {
                    isOpen_1
                        ? add_class_1.default(trigger, _this.options.activeClass)
                        : remove_class_1.default(trigger, _this.options.activeClass);
                    trigger.setAttribute('aria-expanded', isOpen_1.toString().toLowerCase());
                });
            }
        }
    };
    Collapse.getInstance = function (element, options, create) {
        if (create === void 0) { create = true; }
        var data = element[stringCollapse];
        if (!data && create) {
            data = new Collapse(element, options);
        }
        return data;
    };
    return Collapse;
}());
exports.Collapse = Collapse;
function collapse(element, options) {
    console.error('collapse deprecated: use new Collapse(element, options) instead. (initialized elements can be accessed via Collapse.getInstance()');
    var data = element[stringCollapse];
    if (!data) {
        data = new Collapse(element, options);
    }
    return data;
}
exports.default = collapse;
